// src/AdminAccounts.jsx
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
    collection,
    doc,
    getDocs,
    updateDoc,
    deleteDoc
} from 'firebase/firestore';
import { Link, useNavigate } from 'react-router-dom';

function AdminAccounts() {
    const [accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [editedName, setEditedName] = useState('');
    const navigate = useNavigate();

    const fetchAccounts = async () => {
        setLoading(true);
        const snapshot = await getDocs(collection(db, 'roles'));
        const users = snapshot.docs.map(docSnap => ({
            uid: docSnap.id,
            ...docSnap.data()
        }));
        setAccounts(users);
        setLoading(false);
    };

    const handleDeleteAccount = async (uid) => {
        try {
            await deleteDoc(doc(db, 'roles', uid));
            alert('🗑️ Role deleted. Please delete user from Firebase Authentication manually.');
            fetchAccounts();
        } catch (error) {
            alert('❌ Error deleting: ' + error.message);
        }
    };

    const startEdit = (acc) => {
        setEditingId(acc.uid);
        setEditedName(acc.displayName || '');
    };

    const saveEdit = async () => {
        if (editingId && editedName.trim()) {
            const docRef = doc(db, 'roles', editingId);
            await updateDoc(docRef, { displayName: editedName });
            setEditingId(null);
            setEditedName('');
            fetchAccounts();
        }
    };

    useEffect(() => {
        fetchAccounts();
    }, []);

    return (
        <div className="p-6 font-sans">
            <Link to="/account" className="text-blue-600 hover:underline">
                ← Back to Account Portal
            </Link>
            <h2 className="text-2xl font-bold my-4">👥 Manage Accounts</h2>

            <h3 className="text-lg font-semibold mb-2">📋 Existing Roles (from Firestore)</h3>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <ul className="space-y-2">
                    {accounts.map((acc) => (
                        <li key={acc.uid} className="p-3 border rounded bg-gray-50">
                            <p className="text-sm"><strong>Role:</strong> {acc.role}</p>
                            <p className="text-sm"><strong>Email:</strong> {acc.email || 'N/A'}</p>

                            {editingId === acc.uid ? (
                                <div className="flex items-center space-x-2 mt-1">
                                    <input
                                        value={editedName}
                                        onChange={(e) => setEditedName(e.target.value)}
                                        className="p-1 border rounded"
                                        placeholder="New Display Name"
                                    />
                                    <button
                                        onClick={saveEdit}
                                        className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
                                    >
                                        Save
                                    </button>
                                </div>
                            ) : (
                                <>
                                    <p className="text-sm"><strong>Display Name:</strong> {acc.displayName || 'N/A'}</p>
                                    <button
                                        onClick={() => startEdit(acc)}
                                        className="mt-1 bg-yellow-500 text-white px-2 py-1 rounded hover:bg-yellow-600"
                                    >
                                        Edit Display Name
                                    </button>
                                </>
                            )}

                            <button
                                onClick={() => handleDeleteAccount(acc.uid)}
                                className="mt-2 bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                            >
                                Delete Role
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default AdminAccounts;
